<template>
  <div class="estate-container">
    <div class="main-wrap">
      <div class="banner-container">
        <img src="../../../assets/images/estate/estate-banner.jpg" alt="" />
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>新希望地产</span>
          <b class="sub-info">Since 1998</b>
        </p>
      </div>
      <div class="intro-box">
        <div class="intro-box-content">
          <p><br /></p>
          <p>新希望地产于1998年成立，</p>
          <p>为世界500强企业新希望旗下公司。</p>
          <p><br /></p>
          <p>
            二十余年来，新希望地产秉持集团集团“希望，让生活更美好”的初心使命，
          </p>
          <p>贯彻“产品为根 客户为本”的经营理念，</p>
          <p>以“产业与客户的双向连接者，美好生活场景的构筑者”的品牌定位，</p>
          <p>
            长期坚持「城市聚焦、区域聚焦、产品聚焦、服务聚焦、人才聚焦」“五大聚焦战略”，
          </p>
          <p>
            形成了以高品质住宅开发为主，同时涵盖建设管理、乡村振兴、酒店管理、物业服务等经营模式，
          </p>
          <p>实现了资产和经营规模的稳健科学发展。</p>
        </div>
      </div>
      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>发展历程</span>
        </p>
      </div>
      <auto-scroll-image></auto-scroll-image>
      <div class="center-container-wrap">
        <div class="section-container">
          <el-row :gutter="22" class="estate-culture-wrap">
            <el-col
              :span="12"
              class="wow animate__slideInUp"
              data-wow-duration="500ms"
            >
              <div class="estate-culture-item">
                <div class="estate-culture-title">
                  <p
                    class="estate-culture-text"
                    style="margin-top: 0; margin-bottom: 26px"
                  >
                    使命与愿景
                  </p>
                  <div class="info-text-box">
                    <p class="info-text"></p>
                    <p>
                      <span style="font-size: 14px"
                        >我们的使命：希望，让生活更美好</span
                      >
                    </p>
                    <p>
                      <span style="font-size: 14px"
                        >我们的愿景：智慧城乡的耕耘者、美好生活的创造者</span
                      >
                    </p>
                    <p></p>
                  </div>
                </div>
                <div class="estate-culture-img">
                  <img
                    class="img-responsive"
                    src="../../../assets/images/estate/1.png"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
            <el-col
              :span="12"
              class="wow animate__slideInUp"
              data-wow-duration="500ms"
            >
              <div class="estate-culture-item">
                <div class="estate-culture-title">
                  <p
                    class="estate-culture-text"
                    style="margin-top: 0; margin-bottom: 26px"
                  >
                    经营哲学
                  </p>
                  <div class="info-text-box">
                    <p class="info-text"></p>
                    <p>
                      <span style="font-size: 14px"
                        >以“产品为根 客户为本”的经营理念，</span
                      >
                    </p>
                    <p>
                      <span style="font-size: 14px"
                        >长期坚持「城市聚焦、区域聚焦、产品聚焦、服务聚焦、人才聚焦」</span
                      ><span style="font-size: 14px">“五大聚焦战略”，</span>
                    </p>
                    <p>
                      <span style="font-size: 14px"
                        >形成以高品质住宅开发为主的稳健经营模式。</span
                      >
                    </p>
                    <p></p>
                  </div>
                </div>
                <div class="estate-culture-img">
                  <img
                    class="img-responsive"
                    src="../../../assets/images/estate/2.png"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="center-container-wrap">
        <p class="section-title-line">
          <span>全国布局</span>
        </p>
      </div>
      <div class="section-container">
        <div class="intro-box">
          <div class="intro-box-content">
            <p><br /></p>
            <p>每一个重大项目的落地，</p>
            <p>都是我们为改善人居环境、促进城市发展的一次努力。</p>
            <p><br /></p>
            <p>新希望地产坚持以「新一线、强二线为主」的城市群深耕战略，</p>
            <p>
              已在成都、重庆、杭州、南京、广佛、武汉、西安等15个城市群累计运营上百个中高端项目，
            </p>
            <p><br /></p>
            <p>高质量的稳健增长让新希望地产，</p>
            <p>荣获“2023中国房地产百强企业TOP30”，</p>
            <p>“中国房企稳健经营企业十强”。</p>
            <p><br /></p>

            <p>在不断的产品迭代和品质升级中，产品力收获了市场高度的认可，</p>
            <p>2023年取得了“中国房地产企业产品力TOP30”殊荣，</p>

            <p>“D10天系”获得"全国十大顶级豪宅产品系"。</p>
          </div>
        </div>

        <div
          class="dt-img-wrap center-container wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <img
            class="dt-img-item"
            src="../../../assets/images/estate/map.png"
            alt=""
          />

          <div class="city-item city-item1">
            <div>
              <img
                style="animation: city-animation 3s 1s ease-in-out infinite"
                src="../../../assets/images/estate/circle.png"
                alt=""
              />
              <p>西南大本营</p>
            </div>
          </div>
          <div class="city-item city-item2">
            <div>
              <img
                style="animation: city-animation 3s 2s ease-in-out infinite"
                src="../../../assets/images/estate/circle.png"
                alt=""
              />
              <p>环渤海城市群</p>
            </div>
          </div>
          <div class="city-item city-item3">
            <div>
              <img
                style="animation: city-animation 3s 3s ease-in-out infinite"
                src="../../../assets/images/estate/circle.png"
                alt=""
              />
              <p>环沪城市群</p>
            </div>
          </div>
          <div class="city-item city-item4">
            <div>
              <img
                style="animation: city-animation 3s 4s ease-in-out infinite"
                src="../../../assets/images/estate/circle.png"
                alt=""
              />
              <p>华中城市群</p>
            </div>
          </div>
          <div class="city-item city-item5">
            <div>
              <img
                style="animation: city-animation 3s 5s ease-in-out infinite"
                src="../../../assets/images/estate/circle.png"
                alt=""
              />
              <p>粤港澳大湾区</p>
            </div>
          </div>
        </div>

        <div class="city-nav">
          <div :class="[showIndex === 0 && 'city-nav-active']" @click="showIndex=0"><p>西南大本营</p></div>
          <div :class="[showIndex === 1 && 'city-nav-active']" @click="showIndex=1"><p>环渤海城市群</p></div>
          <div :class="[showIndex === 2 && 'city-nav-active']" @click="showIndex=2"><p>环沪城市群</p></div>
          <div :class="[showIndex === 3 && 'city-nav-active']" @click="showIndex=3"><p>华中城市群</p></div>
          <div :class="[showIndex === 4 && 'city-nav-active']" @click="showIndex=4"><p>粤港澳大湾区</p></div>
        </div>

        <div class="city-box">
          <div class="city-item" v-show="showIndex===0">
            <div class="city-cover">
              <img
                style="width: 100%"
                src="../../../assets/images/estate/xinan.jpg"
                alt=""
              />
            </div>

            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">成都</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·D10天府</p>
                  <p class="city-item-project">新希望·长粼府</p>
                  <p class="city-item-project">新希望·锦麟壹品</p>
                  <p class="city-item-project">新希望·锦麟府</p>
                  <p class="city-item-project">新希望·锦麟天玺</p>
                  <p class="city-item-project">新希望·锦粼云境</p>
                  <p class="city-item-project">新希望·锦粼湖院</p>
                  <p class="city-item-project">新希望·锦官府</p>
                  <p class="city-item-project">新希望·锦官阁</p>
                  <p class="city-item-project">新希望·锦官印悦</p>
                  <p class="city-item-project">新希望·锦官天樾</p>
                  <p class="city-item-project">新希望·锦官天宸</p>
                  <p class="city-item-project">新希望·锦官新城</p>
                  <p class="city-item-project">新希望·锦官秀城</p>
                  <p class="city-item-project">新希望·锦官丽城</p>
                  <p class="city-item-project">新希望·锦悦楠庭</p>
                  <p class="city-item-project">新希望·锦悦北府</p>
                  <p class="city-item-project">新希望·怡心湖岸</p>
                  <p class="city-item-project">新希望·西樾锦宸</p>
                  <p class="city-item-project">新希望·塔子山壹号</p>
                  <p class="city-item-project">新希望·桐梓林壹号</p>
                  <p class="city-item-project">新希望·皇冠湖壹号</p>
                  <p class="city-item-project">新希望·堤亚纳河谷</p>
                  <p class="city-item-project">新希望·皇冠国际</p>
                  <p class="city-item-project">新希望·望津山</p>
                  <p class="city-item-project">新希望·红南港</p>
                  <p class="city-item-project">新希望·毕节锦悦城</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>写字楼</p>
                  <p class="city-item-project">新希望大厦</p>
                  <p class="city-item-project">新希望国际</p>
                  <p class="city-item-project">新希望·商鼎国际</p>
                  <p class="city-item-project">新希望·中鼎国际</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>文旅</p>
                  <p class="city-item-project">新希望种子乐园</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>酒店</p>
                  <p class="city-item-project">成都新希望高新皇冠假日酒店®️</p>
                  <p class="city-item-project">成都新希望武侯智选假日酒店®️</p>
                  <p class="city-item-project">成都新希望高新中心假日酒店®️</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">重庆</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·D10天际</p>
                  <p class="city-item-project">新希望·翡丽锦悦</p>
                  <p class="city-item-project">新希望·璟樾云山</p>
                  <p class="city-item-project">新希望·观山御璟</p>
                  <p class="city-item-project">新希望·中央云璟</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">昆明</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟峯荟</p>
                  <p class="city-item-project">新希望·锦粼天序</p>
                  <p class="city-item-project">新希望·希望汇</p>
                  <p class="city-item-project">新希望·观澜汇</p>
                  <p class="city-item-project">新希望·白麓城</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>综合体</p>
                  <p class="city-item-project">新希望·大商汇</p>
                </div>
              </el-col>
            </el-row>

            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">南宁</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦官府</p>
                  <p class="city-item-project">新希望·锦麟玖玺</p>
                  <p class="city-item-project">新希望·锦悦青山</p>
                  <p class="city-item-project">新希望·锦悦江南</p>
                  <p class="city-item-project">新希望·锦云湖光</p>
                  <p class="city-item-project">新希望·盛湖悦景</p>
                  <p class="city-item-project">新希望·盛世金悦</p>
                  <p class="city-item-project">新希望·大唐印象</p>
                  <p class="city-item-project">新希望·国际住区</p>
                  <p class="city-item-project">新希望·锦官城</p>
                  <p class="city-item-project">新希望·希望城</p>
                  <p class="city-item-project">新希望·锦城</p>
                  <p class="city-item-project">臻园</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>综合体</p>
                  <p class="city-item-project">新希望·大商汇</p>
                  <p class="city-item-project">新希望·国际家居博览中心</p>
                  <p class="city-item-project">新希望·东盟国际红木城</p>
                  <p class="city-item-project">新希望·国际建材城</p>
                  <p class="city-item-project">新畅行·智慧汽车MALL</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="city-item" v-show="showIndex===1">
            <div class="city-cover">
              <img
                style="width: 100%"
                src="../../../assets/images/estate/huanbohai.jpg"
                alt=""
              />
            </div>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">大连</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟玖玺</p>
                  <p class="city-item-project">新希望·璞石墅</p>
                  <p class="city-item-project">新希望·御栖湖</p>
                  <p class="city-item-project">新希望家园</p>
                  <p class="city-item-project">新希望乐城</p>
                  <p class="city-item-project">新希望花园</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">大连</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟玖玺</p>
                  <p class="city-item-project">新希望·璞石墅</p>
                  <p class="city-item-project">新希望·御栖湖</p>
                  <p class="city-item-project">新希望家园</p>
                  <p class="city-item-project">新希望乐城</p>
                  <p class="city-item-project">新希望花园</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">青岛</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>酒店</p>
                  <p class="city-item-project">青岛新希望·诺富特酒店®️</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>总部工业园</p>
                  <p class="city-item-project">六和中试基地</p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="city-item" v-show="showIndex===2">
            <div class="city-cover">
              <img
                style="width: 100%"
                src="../../../assets/images/estate/huanhu.jpg"
                alt=""
              />
            </div>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">上海</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>总部工业园</p>
                  <p class="city-item-project">新希望·半岛科技园</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">南京</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">锦麟融誉府</p>
                  <p class="city-item-project">天悦锦麟</p>
                  <p class="city-item-project">紫樾府</p>
                  <p class="city-item-project">云澜尚府</p>
                  <p class="city-item-project">水沐雍荣府</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">杭州</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦宸</p>
                  <p class="city-item-project">新希望·锦粼府</p>
                  <p class="city-item-project">新希望·长粼府</p>
                  <p class="city-item-project">新希望·拥潮府</p>
                  <p class="city-item-project">新希望·悦潮府</p>
                  <p class="city-item-project">新希望·锦粼云荟</p>
                  <p class="city-item-project">新希望·锦畔云汀</p>
                  <p class="city-item-project">新希望·锦翠栖源府</p>
                  <p class="city-item-project">新希望·未来海岸</p>
                  <p class="city-item-project">新希望·澄品101</p>
                  <p class="city-item-project">新希望·荣望轩</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">温州</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·玉锦麟</p>
                  <p class="city-item-project">新希望·立体城</p>
                  <p class="city-item-project">新希望·白麓城</p>
                  <p class="city-item-project">新希望·堇辰府</p>
                  <p class="city-item-project">新希望·天麓</p>
                  <p class="city-item-project">学院·十一峯</p>
                  <p class="city-item-project">江境1265</p>
                  <p class="city-item-project">瑞祥天樾</p>
                  <p class="city-item-project">江屿云庄</p>
                  <p class="city-item-project">都会外滩</p>
                  <p class="city-item-project">风华剑桥</p>
                  <p class="city-item-project">西江月</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>综合体</p>
                  <p class="city-item-project">立体城商业综合体</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>写字楼</p>
                  <p class="city-item-project">新希望·瓯江国际</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">宁波</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·堇麟上府</p>
                  <p class="city-item-project">新希望·江望云著</p>
                  <p class="city-item-project">新希望·堇天府</p>
                  <p class="city-item-project">新希望·长粼府</p>
                  <p class="city-item-project">新希望·映辰府</p>
                  <p class="city-item-project">新希望·滨辰府</p>
                  <p class="city-item-project">新希望·宸芯里</p>
                  <p class="city-item-project">新希望·万象府</p>
                  <p class="city-item-project">新希望·云堇台</p>
                  <p class="city-item-project">新希望·宁荟台</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>文旅</p>
                  <p class="city-item-project">新希望·初新营地</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">苏州</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟府</p>
                  <p class="city-item-project">新希望·锦麟壹品</p>
                  <p class="city-item-project">新希望·锦麟芳华</p>
                  <p class="city-item-project">新希望·锦麟云境</p>
                  <p class="city-item-project">新希望·锦麟九里</p>
                  <p class="city-item-project">新希望·湖东未来</p>
                  <p class="city-item-project">新希望·四季春晓</p>
                  <p class="city-item-project">新希望·阅湖山</p>
                  <p class="city-item-project">锦麟铂悦府</p>
                  <p class="city-item-project">大境公园时代</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">嘉兴</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟天樾</p>
                  <p class="city-item-project">新希望·锦麟澜湾</p>
                  <p class="city-item-project">新希望·锦粼鸣庐</p>
                  <p class="city-item-project">新希望·锦棠里</p>
                  <p class="city-item-project">新希望·鹭栖湖</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>

            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">舟山</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>总部工业园</p>
                  <p class="city-item-project">中澳现代产业园</p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="city-item" v-show="showIndex===3">
            <div class="city-cover">
              <img
                style="width: 100%"
                src="../../../assets/images/estate/huazhong.jpg"
                alt=""
              />
            </div>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">武汉</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·D10天元</p>
                  <p class="city-item-project">新希望·锦粼九里</p>
                  <p class="city-item-project">雍禧兰台</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">西安</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦麟天玺</p>
                  <p class="city-item-project">未来印</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="city-item" v-show="showIndex===4">
            <div class="city-cover">
              <img
                style="width: 100%"
                src="../../../assets/images/estate/yuegangao.jpg"
                alt=""
              />
            </div>
            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">广州</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·金洲府</p>
                </div>
              </el-col>
            </el-row>

            <el-row class="city-item-fx">
              <el-col :span="6">
                <div>
                  <p class="city-item-name">佛山</p>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="city-item-list">
                  <p>住宅</p>
                  <p class="city-item-project">新希望·锦官半岛</p>
                  <p class="city-item-project">新希望·金沙公馆</p>
                  <p class="city-item-project">新希望·悦珑湾</p>
                  <p class="city-item-project"></p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AutoScrollImage from "@/components/autoScrollImage";
export default {
  name: "EstatePage",
  components: {
    AutoScrollImage,
  },
  data() {
    return {
      showIndex: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.estate-container {
  background-color: #fff;
  .banner-container {
    width: 100%;
    padding: 0 -15px;
    margin: 0 auto;
    overflow: hidden;

    > img {
      width: 100%;
    }
  }

  .intro-box {
    background-color: #fff;
    .intro-box-content {
      > p {
        text-align: center;
        font-size: 16px;
        color: #565c61;
        font-weight: 300;
        line-height: 35px;
      }
    }
  }

  .sub-info {
    position: absolute;
    left: 50%;
    bottom: 10%;
    transform: translateX(-50%);
    font-weight: normal;
    font-size: 22px;
    color: #3c4347;
    text-align: center;
  }

  .estate-culture-item {
    border: 1px solid #565c62;
    padding: 16px;
  }

  .estate-culture-title {
    height: 204px;
    padding-top: 10px;
  }

  .estate-culture-text {
    font-size: 32px;
    line-height: 32px;
    font-weight: 400;
    color: #3c4347;
    margin-bottom: 26px;
    margin-top: 0;
  }

  .info-text,
  .info-text-box p,
  .info-text-box span {
    font-size: 13px;
    font-weight: 300;
    color: #565c61;
    line-height: 30px;
    text-align: justify;
    text-justify: inter-word;
  }

  .estate-culture-wrap {
    margin-top: 60px;
  }

  .estate-culture-img {
    overflow: hidden;

    > img {
      transition: all 0.3s linear;
      width: 100%;
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .dt-img-wrap {
    height: 820px;
    width: 1170px;
    position: relative;
    text-align: center;
    padding: 40px 0;
    box-sizing: border-box;
    margin: 0 auto;

    .dt-img-item {
      width: 700px;
    }

    .city-item {
      height: 150px;
      width: 150px;
      position: absolute;
      img {
        opacity: 0.4;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      p {
        position: absolute;
        width: 100%;
        text-align: center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 18px;
      }
    }

    .city-item1 {
      left: 45.5%;
      top: 46.5%;
    }

    .city-item2 {
      left: 61%;
      top: 24.8%;
    }

    .city-item3 {
      left: 64%;
      top: 42%;
    }

    .city-item4 {
      left: 53.5%;
      top: 36.5%;
    }

    .city-item5 {
      left: 56.5%;
      top: 52.5%;
    }
  }

  .city-nav {
    display: flex;
    justify-content: center;
    align-items: center;

    > div {
      width: 148px;
      height: 60px;
      margin: 0 10px;
      border: 1px solid #565c61;
      transition: all 0.3s ease-in-out;
      text-align: center;
      cursor: pointer;

      > p {
        font-size: 16px;
        line-height: 60px;
      }
    }

    .city-nav-active {
      color: #008048;
      border-color: #008048;
    }
  }

  .city-item {
    .city-cover {
      height: 100%;
      padding-top: 60px;
    }

    .city-item-fx {
      padding: 50px 0;
      border-bottom: 1px solid #b2b2b2;
    }

    .city-item-name {
      font-size: 24px;
      color: #008048;
    }

    .city-item-list {
      > p:first-child {
        font-size: 16px;
        line-height: 16px;
        margin: 12px 0 17px;
        color: #565c61;
      }
    }

    .city-item-project {
      width: 85%;
      font-size: 13px;
      color: #565c61;
      text-align: justify;
      font-weight: 400;
      line-height: 24px;
    }
  }
}
</style>

<style>
@keyframes city-animation {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}
</style>
